import _ from "lodash";

import { GroupsState } from "./slice";

export const canFetchGroups = (state: GroupsState) => !state.request.active;

export const getGroupNames = (state: GroupsState) => _.keys(state.groups).sort();

export const getGroups = (state: GroupsState) => _.orderBy(state.groups, "name");
